import { useState, FormEvent } from "react";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d776eet5uau42b5in380", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="iletisim" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-[#e8734a] text-sm font-semibold mb-4">
            <i className="ri-map-pin-line"></i>
            İletişim
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a4a] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Bize Ulaşın
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Rezervasyon, bilgi veya özel etkinlikler için bizimle iletişime geçin
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left: Info */}
          <div>
            <div className="space-y-6 mb-10">
              {[
                {
                  icon: "ri-map-pin-2-line",
                  title: "Adres",
                  lines: ["Kazımdimdirik Mah. Atatürk Cad. No:101/A", "Aliağa, İzmir"],
                },
                {
                  icon: "ri-phone-line",
                  title: "Telefon",
                  lines: ["+90 (232) 000 00 00"],
                },
                {
                  icon: "ri-time-line",
                  title: "Çalışma Saatleri",
                  lines: ["Pazartesi - Pazar", "11:00 - 22:00"],
                },
                {
                  icon: "ri-instagram-line",
                  title: "Sosyal Medya",
                  lines: ["@balikci_zafer"],
                },
              ].map((info) => (
                <div key={info.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#e8734a]/10 rounded-xl flex-shrink-0">
                    <i className={`${info.icon} text-[#e8734a] text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-[#1a3a4a] font-semibold text-sm mb-0.5">{info.title}</div>
                    {info.lines.map((line) => (
                      <div key={line} className="text-gray-500 text-sm">{line}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden h-52 border border-gray-100">
              <iframe
                title="Balıkçı Zafer Konum"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3124.5!2d26.9726!3d38.8047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b9b8c0a0a0a0a1%3A0x0!2sAtat%C3%BCrk%20Cd.%20No%3A101%2FA%2C%20Kaz%C4%B1mdimdirik%2C%20Alia%C4%9Fa%2C%20%C4%B0zmir!5e0!3m2!1str!2str!4v1700000000001"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-[#faf9f7] rounded-2xl p-8">
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-full py-12 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#e8734a]/10 rounded-full mb-4">
                  <i className="ri-check-line text-[#e8734a] text-3xl"></i>
                </div>
                <h3 className="text-[#1a3a4a] font-bold text-xl mb-2">Mesajınız Alındı!</h3>
                <p className="text-gray-500 text-sm">En kısa sürede size geri dönüş yapacağız.</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="contact-form"
                onSubmit={handleSubmit}
                className="space-y-5"
              >
                <h3 className="text-[#1a3a4a] font-bold text-xl mb-6">Mesaj Gönderin</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[#1a3a4a] text-sm font-medium mb-1.5">Ad Soyad</label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Adınız Soyadınız"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a3a4a] placeholder-gray-400 focus:outline-none focus:border-[#e8734a] bg-white"
                    />
                  </div>
                  <div>
                    <label className="block text-[#1a3a4a] text-sm font-medium mb-1.5">Telefon</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="0532 000 00 00"
                      className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a3a4a] placeholder-gray-400 focus:outline-none focus:border-[#e8734a] bg-white"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-[#1a3a4a] text-sm font-medium mb-1.5">E-posta</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="ornek@email.com"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a3a4a] placeholder-gray-400 focus:outline-none focus:border-[#e8734a] bg-white"
                  />
                </div>

                <div>
                  <label className="block text-[#1a3a4a] text-sm font-medium mb-1.5">Konu</label>
                  <select
                    name="subject"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a3a4a] focus:outline-none focus:border-[#e8734a] bg-white cursor-pointer"
                  >
                    <option value="rezervasyon">Rezervasyon</option>
                    <option value="bilgi">Bilgi Almak İstiyorum</option>
                    <option value="ozel-etkinlik">Özel Etkinlik</option>
                    <option value="diger">Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-[#1a3a4a] text-sm font-medium mb-1.5">Mesajınız</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Mesajınızı buraya yazın... (max 500 karakter)"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-[#1a3a4a] placeholder-gray-400 focus:outline-none focus:border-[#e8734a] bg-white resize-none"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#e8734a] text-white py-3.5 rounded-xl font-semibold text-sm hover:bg-[#d4623a] transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-60"
                >
                  {loading ? (
                    <><i className="ri-loader-4-line animate-spin"></i> Gönderiliyor...</>
                  ) : (
                    <><i className="ri-send-plane-line"></i> Mesaj Gönder</>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
